export const E = {
  UNEXPECTEDFETCH: 'API Generic Error: inconsistent response',
  SESSIONEXPIRED: 'Session Expired'
};
